import dotenv from 'dotenv';

dotenv.config();

console.log("DOTENV", process.env)
